import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationIndividual1MasterReferenceData = createAsyncThunk(
  'stop/getVerificationIndividual1MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationIndividual1MasterReferenceSlice = createSlice({
  name: 'stop/verificationIndividual1MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationIndividual1MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationIndividual1MasterReferenceData.fulfilled]: (
      state,
      action
    ) => action.payload,
  },
});

export const { resetVerificationIndividual1MasterReference } =
  verificationIndividual1MasterReferenceSlice.actions;

export default verificationIndividual1MasterReferenceSlice.reducer;
